import React from 'react'

// ArComponents
import ArPartners from 'src/components/ArPartners/ArPartners'
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArCTASection from 'src/components/ArCTASection/ArCTASection'
import ArTestimonials from 'src/components/ArTestimonials/ArTestimonials'
import ArTextWithImageHalvedOnTablet from 'src/components/ArTextWithImageHalvedOnTablet/ArTextWithImageHalvedOnTablet'
import ArSeo from 'src/components/ArSeo/ArSeo'

// Data
import DaDataCommon from 'src/data/DataCommon'
import DaPageProductPrice from 'src/data/PageProductPrice'
import routesConfig from 'src/routes.config'

export default class ProductsPricePage extends React.Component {
  render () {
    return (
      <React.Fragment>
        <ArSeo
          title={DaPageProductPrice.metadata.title}
          description={DaPageProductPrice.metadata.desc}
          path={routesConfig.useCases.optimisePricing()}
        />

        {(() => {
          const { image, title, description, cta } = DaPageProductPrice.ArHeroHeader
          return (
            <ArHeroHeader
              variant="product-price"
              image={image}
              title={title}
              description={description}
              cta={cta}
            />
          )
        })()}

        {(() => {
          const { items } = DaPageProductPrice.ArTextWithImageHalvedOnTablet

          return items.map(({ title, description, image, ...scRest }, index) =>
            <ArTextWithImageHalvedOnTablet
              key={index}
              image={image}
              title={title}
              description={description}
              scImageToRight={!!((index + 1) % 2)}
              { ...scRest }
            />
          )
        })()}

        {(() => {
          const { title, logos } = DaDataCommon.ArPartners

          return (
            <ArPartners title={title} logos={logos} />
          )
        })()}

        {(() => {
          return (
            <ArTestimonials testimonials={DaDataCommon.ArTestimonials} />
          )
        })()}

        {(() => {
          const { title, cta, backgroundColor } = DaDataCommon.ArCTASection

          return (
            <ArCTASection title={title} cta={cta} scBackgroundColor={backgroundColor} />
          )
        })()}
      </React.Fragment>
    )
  }
}
